/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonInviteReplyExtra
 */
export interface JsonInviteReplyExtra {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonInviteReplyExtra
     */
    allowedActions?: Array<JsonInviteReplyExtraAllowedActionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    approvedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    approvedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    approvedStatus?: JsonInviteReplyExtraApprovedStatusEnum;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonInviteReplyExtra
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    createdBy?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof JsonInviteReplyExtra
     */
    eventDayNos?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    eventDays?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    extraId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    photoCvResult?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    photoGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    photoId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    replyExtraId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    replyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    sex?: JsonInviteReplyExtraSexEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    status?: JsonInviteReplyExtraStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyExtra
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyExtra
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonInviteReplyExtraAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonInviteReplyExtraApprovedStatusEnum {
    Rejected = 'REJECTED',
    Approved = 'APPROVED'
}/**
* @export
* @enum {string}
*/
export enum JsonInviteReplyExtraSexEnum {
    M = 'M',
    F = 'F'
}/**
* @export
* @enum {string}
*/
export enum JsonInviteReplyExtraStatusEnum {
    Rejected = 'REJECTED',
    Pending = 'PENDING',
    Linked = 'LINKED',
    Created = 'CREATED'
}

export function JsonInviteReplyExtraFromJSON(json: any): JsonInviteReplyExtra {
    return JsonInviteReplyExtraFromJSONTyped(json, false);
}

export function JsonInviteReplyExtraFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonInviteReplyExtra {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'approvedAt': !exists(json, 'approvedAt') ? undefined : json['approvedAt'],
        'approvedBy': !exists(json, 'approvedBy') ? undefined : json['approvedBy'],
        'approvedStatus': !exists(json, 'approvedStatus') ? undefined : json['approvedStatus'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'eventDayNos': !exists(json, 'eventDayNos') ? undefined : json['eventDayNos'],
        'eventDays': !exists(json, 'eventDays') ? undefined : json['eventDays'],
        'extraId': !exists(json, 'extraId') ? undefined : json['extraId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'photoCvResult': !exists(json, 'photoCvResult') ? undefined : json['photoCvResult'],
        'photoGuid': !exists(json, 'photoGuid') ? undefined : json['photoGuid'],
        'photoId': !exists(json, 'photoId') ? undefined : json['photoId'],
        'replyExtraId': !exists(json, 'replyExtraId') ? undefined : json['replyExtraId'],
        'replyId': !exists(json, 'replyId') ? undefined : json['replyId'],
        'sex': !exists(json, 'sex') ? undefined : json['sex'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonInviteReplyExtraToJSON(value?: JsonInviteReplyExtra | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'approvedAt': value.approvedAt,
        'approvedBy': value.approvedBy,
        'approvedStatus': value.approvedStatus,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'eventDayNos': value.eventDayNos,
        'eventDays': value.eventDays,
        'extraId': value.extraId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'partyId': value.partyId,
        'photoCvResult': value.photoCvResult,
        'photoGuid': value.photoGuid,
        'photoId': value.photoId,
        'replyExtraId': value.replyExtraId,
        'replyId': value.replyId,
        'sex': value.sex,
        'status': value.status,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

